import React from "react";

const ChartWrapper = ({ mode, children }) => {
  return (
    <React.Fragment>
      {mode && mode === "page" ? (
        <div style={{ minHeight: "50vh", maxHeight: "70vh" }}>{children}</div>
      ) : (
        <React.Fragment>{children}</React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ChartWrapper;
